<template>
  <div class="keyword">
    <div class="input-container">
      <label>Keyword Density Test</label>
      <input class="input" autocomplete="off" v-model="keyword" />
    </div>
    <div v-if="keyword.length > 0">
      <span>{{ density }}%</span>
      <span v-if="wordCount.length > 0">Total word count: {{ wordCount }}</span>
      <button @click="getKeywordDensity()">Calculate</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    task: Object,
  },
  data() {
    return {
      keyword: '',
      density: 0,
      wordCount: 0,
    }
  },
  methods: {
    getKeywordDensity() {
      this.disableButtons = true
      let url = 'https://europe-west3-freelance-dev-df97d.cloudfunctions.net/task?endpoint=keyworddensity'
      var _this = this
      var formData = {
        task: this.task,
        keyword: this.keyword,
      }
      axios
        .post(url, formData, {
          headers: {
            Authorization: this.user.data.uid,
          },
        })
        .then(function(response) {
          console.log(response.data)
          _this.wordCount = response.data.wordCount
          _this.density = response.data.keywordDensity
        })
        .catch(function(response) {
          _this.$notify({
            text: 'Failed to calculate keyword density',
            type: 'error',
          })
        })
        .then(function() {
          _this.disableButtons = false
        })
    },
  },
  computed: {
    ...mapGetters(['user']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/input.scss';

.keyword {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  span {
    margin-top: 0.75rem;
    margin-left: 0.5rem;
    font-size: 0.875rem;
  }
}
</style>
